import MainComponent from "components/Main";
import PropTypes from "prop-types";

import './index.less';

import CheckBox from "components/CheckBox";


/**
 * Created by viclight on 04.03.2024.
 */
export default class SpecItem extends MainComponent {


    static propTypes = {
        item: PropTypes.object,
        select: PropTypes.bool,
        onChange: PropTypes.func
    };

    static defaultProps = {
        item: { id: 0, title: "" },
        select: false,
        onChange: null
    };


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            select: this.props.select,
            item: this.props.item
        };

    }

    insertCheckBox(props) {
        return <CheckBox {...props} />;
    }

    changeSelect() {

        const { item, onChange, used } = this.props;

        if (used) {
            if (onChange !== null) {
                onChange(item, !this.state.select);
            }

            this.setState({ select: !this.state.select });
        }

    }
    render() {
        const { item, select } = this.state;

        return (
            <div className="specItem flex flex1">
                <div className="flex flex1">
                    {this.insertCheckBox({
                        ref: el => this.check = el,
                        checked: select,
                        title: item.title,
                        onClick: this.changeSelect.bind(this)
                    })}
                </div>

            </div>
        );
    }

}
